const filter = require('lodash/filter')

module.exports = ['$scope', '$state', 'User', '$loading', '$ionicListDelegate', '$ionicHistory', '$rootScope',
  function ($scope, $state, User, $loading, $ionicListDelegate, $ionicHistory, $rootScope) {
    const userConfig = User.getConfig()
    $scope.userConfig = userConfig
    $scope.avatarInfo = {
      email: userConfig['email'],
      name: userConfig['true_name']
    }

    $scope.resetMode = function () {
      if ($rootScope.settings.wechatMiniProgram) return
      switch ($state.current.name) {
        case 'frame.folder':
          LA.track('A1B1')
          break
        case 'frame.contactList':
          LA.track('A2B1')
          break
        case 'frame.netFolder':
          LA.track('A3B1')
          break
      }
      $loading.hide()
      $scope.$broadcast('SWITCH_MENU')
      $ionicListDelegate.closeOptionButtons()
    }

    $scope.currentSubFrame = (window.sessionStorage && sessionStorage.getItem('currentSubFrame')) || 'mails'
    $scope.goSubFrame = function (frame, param = {}) {
      if (frame !== 'compose') {
        $ionicHistory.nextViewOptions({
          disableAnimate: true
        })
      }
      window.sessionStorage && sessionStorage.setItem('currentSubFrame', frame)
      $scope.currentSubFrame = frame
      switch (frame) {
        case 'mails':
          LA.track('A1')
          $state.go('frame.folder', { fid: 1 })
          break
        case 'addressBook':
          LA.track('A2')
          if ($rootScope.settings.featureControl.addressBook.enableOrganization) {
            $state.go('frame.contactList', { path: '/' })
          } else {
            $state.go('frame.personalContact')
          }
          break
        case 'fileCenter':
          LA.track('A3')
          const allSubItems = [
            { item: { state: 'frame.nfList', param: { type: 'ent', path: '/0' } }, isEnable: $rootScope.hasEntNetfolder && $scope.settings.featureControl.fileCenter.enableEnterpriseNetworkDisk },
            { item: { state: 'frame.nfList', param: { type: 'per', path: '/0' } }, isEnable: $rootScope.hasPerNetfolder && $scope.settings.featureControl.fileCenter.enablePersonalNetworkDisk },
            { item: { state: 'frame.nfList', param: { type: 'ftc', path: '/0' } }, isEnable: $scope.settings.featureControl.fileCenter.enableFileTransitCenter },
            { item: { state: 'frame.nfList', param: { type: 'rel', path: '/0' } }, isEnable: $scope.settings.featureControl.fileCenter.enableRelatedAccessory },
          ]
          const enableSubItems = filter(allSubItems, item => item.isEnable)
          if (enableSubItems.length !== 1) {
            $state.go('frame.netFolder')
          } else {
            $state.go(enableSubItems[0].item.state, enableSubItems[0].item.param)
          }
          break
        case 'setting':
          LA.track('A5')
          $state.go('frame.setting')
          break
        case 'compose':
          LA.track('A1D2')
          $state.go('frame.compose')
          break
        case 'schedule':
          LA.track('A4')
          $state.go('frame.schedule')
          break
      }
    }

    // $scope.openScheduleModal = function () {
    //   $scope.scheduleModal = $phoneModal.fromTemplate(require('views/schedule/scheduleModal.html'), {
    //     scope: $scope,
    //     animation: 'slide-in-up'
    //   })
    //   $scope.scheduleModal.el.style.zIndex = 11
    //   $scope.scheduleModal.show()
    //   setTimeout(_ => {
    //     $loading.show()
    //     const ln = document.querySelector('#scheduleModal')
    //     ln.src = FRAME_SRC
    //     ln.onload = function () {
    //       $loading.hide()
    //     }
    //   }, 500)
    // }

    $scope.today = new Date().getDate()

    // window.addEventListener('message', function (e) {
    //   if (e.data === 'schedule') {
    //     $scope.closeScheduleModal()
    //   }
    // })
    // $scope.closeScheduleModal = function () {
    //   $scope.scheduleModal.remove()
    // }
  }]



// WEBPACK FOOTER //
// ./src/js/controllers/sideMenuCtrl.js